import { IDocumentResponse } from 'src/models/DocumentResponse';
import { DocumentService } from 'src/state/Document';

export const getDocumentTitleHash = (document: IDocumentResponse) =>
  DocumentService.isPDF(document.mimeType) ? document.hash : null;
